function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_498",
  "data-name": "Path 498",
  d: "M706.813,446.49a3.214,3.214,0,0,0,2.5-3.752,3.156,3.156,0,0,0-.154-.536l8.574-7.391-5.605-1.586-7.283,7.262a3.226,3.226,0,0,0-1.543,4.259A3.141,3.141,0,0,0,706.813,446.49Z",
  transform: "translate(-557.021 -359.271)",
  fill: "#ffb6b6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_499",
  "data-name": "Path 499",
  d: "M890.4,648.458l.312-7.007a22.629,22.629,0,0,1,10.556-2.672c-5.07,4.145-4.436,12.135-7.873,17.709a13.612,13.612,0,0,1-9.982,6.29l-4.242,2.6a22.81,22.81,0,0,1,4.808-18.484,22.032,22.032,0,0,1,4.049-3.762C889.039,645.808,890.4,648.458,890.4,648.458Z",
  transform: "translate(-684.926 -508.824)",
  fill: "#f2f2f2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_500",
  "data-name": "Path 500",
  d: "M698.917,521.818h-3.842L693.248,507h5.67Z",
  transform: "translate(-504.378 -368.872)",
  fill: "#ffb6b6"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_501",
  "data-name": "Path 501",
  d: "M851.739,718.956H839.352V718.8a4.821,4.821,0,0,1,4.821-4.821h0l2.263-1.717,4.221,1.717h1.081Z",
  transform: "translate(-656.22 -562.286)",
  fill: "#2f2e41"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_502",
  "data-name": "Path 502",
  d: "M633.409,521.818h-3.841L627.74,507h5.67Z",
  transform: "translate(-456.717 -368.872)",
  fill: "#ffb6b6"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_503",
  "data-name": "Path 503",
  d: "M786.23,718.956H773.844V718.8a4.821,4.821,0,0,1,4.821-4.821h0l2.263-1.717,4.222,1.717h1.081Z",
  transform: "translate(-608.559 -562.286)",
  fill: "#2f2e41"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_504",
  "data-name": "Path 504",
  d: "M792.965,425.826l24.987.625c4.746,2.578,4.818,8.156,3.263,14.78,0,0,.525,3.937-.525,4.987s-1.575,1.05-1.05,2.887-2.248,4.838-1.912,5.175a13.576,13.576,0,0,1,1.124,2.174l-2.625,14.96s-1.837,25.983-2.362,26.508-1.05,0-.525,1.312,1.05.787.525,1.312a19.316,19.316,0,0,0-1.312,1.575h-6.346s-.478-2.625-.478-2.887-.525-1.837-.525-2.1.464-.726.464-.726a8.631,8.631,0,0,0,.323-1.636c0-.525,1.575-20.734,1.575-20.734l-3.149-26.246-7.611,25.721s0,22.571-.525,23.1-.525.262-.262,1.312,1.312.787.525,1.575-1.05-.525-.787.787l.263,1.312-7.874.113s-1.05-2.212-.525-3,.493-.572-.147-1.861-.9-1.551-.64-1.813.263-1.658.263-1.658l1.312-25.112s.263-26.508.263-27.3a2.618,2.618,0,0,0-.218-1.181v-1.069l1.005-3.787Z",
  transform: "translate(-617.936 -353.888)",
  fill: "#2f2e41"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_505",
  "data-name": "Path 505",
  d: "M715.921,329.121l4.223,3.406,23.021-17.845L741.8,283.623h0a12.543,12.543,0,0,0-4.638,8.474l-3.944,17.545Z",
  transform: "translate(-566.417 -250.428)",
  fill: "#e6e6e6"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_506",
  "data-name": "Path 506",
  d: "M795.921,299.825c8.149,1.041,15.657-2.114,22.749-4.5,3.2-1.075,6.427.047,9.4-1.771-1.285-12.66-.037-26.919,2.693-42.116a3.6,3.6,0,0,0-2.448-4.072l-8.8-2.524-2.709-2.988-7,1.776-2.449,4.426-8.415,5.686a3.076,3.076,0,0,0-1.31,3.073A100.863,100.863,0,0,1,795.921,299.825Z",
  transform: "translate(-624.622 -220.042)",
  fill: "#e6e6e6"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_507",
  "data-name": "Path 507",
  d: "M879.021,431.042a3.214,3.214,0,0,0,1.38-4.292,3.159,3.159,0,0,0-.3-.474l6.232-9.45-5.825,0-5.025,8.973a3.226,3.226,0,0,0-.322,4.518,3.141,3.141,0,0,0,3.855.72Z",
  transform: "translate(-681.714 -347.34)",
  fill: "#ffb6b6"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path_508",
  "data-name": "Path 508",
  d: "M884.921,309.3l3.814,4.9,13.35-19.888-1.155-20.205a15.283,15.283,0,0,0-7.836-12.488h0l.272,31.058Z",
  transform: "translate(-689.374 -234.421)",
  fill: "#e6e6e6"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_233",
  "data-name": "Ellipse 233",
  cx: 8.537,
  cy: 8.537,
  r: 8.537,
  transform: "translate(177.425 3.587)",
  fill: "#ffb6b6"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "Path_509",
  "data-name": "Path 509",
  d: "M821.548,168.892a4.033,4.033,0,0,1,.979.128,13.935,13.935,0,0,0,1.916.321,8.879,8.879,0,0,1,7.95,7.531c.5-.432,1.625-1.228,2.55-.489h0c.014.012.022.018.055,0,.614-.291,1.705-3.879,1.738-7.038.018-1.677-.246-3.818-1.6-4.5l-.071-.036-.019-.078c-.091-.377-1.1-1.021-2.862-1.522-3.2-.911-7.963-2.685-10.646-.074-.2.88-.864,2.764-1.531,2.977-.739.236-1.377.44-1.478,1.347a27.8,27.8,0,0,0,.018,3.874,3.957,3.957,0,0,1,1.406-1.974A2.786,2.786,0,0,1,821.548,168.892Z",
  transform: "translate(-641.026 -161.778)",
  fill: "#2f2e41"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "Path_510",
  "data-name": "Path 510",
  d: "M403.01,736.166a.323.323,0,0,1-.324.324h-235.2a.324.324,0,1,1,0-.648h235.2a.323.323,0,0,1,.324.324Z",
  transform: "translate(-167.165 -579.443)",
  fill: "#ccc"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "Path_511",
  "data-name": "Path 511",
  d: "M431.942,262.685l-32.046,7.21a3.324,3.324,0,0,0-2.511,3.968l8.787,39.059,37.652-8.471a1.65,1.65,0,0,0,.815-.45l-8.73-38.8A3.324,3.324,0,0,0,431.942,262.685Z",
  transform: "translate(-334.605 -235.135)",
  fill: "#e6e6e6"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  id: "Path_512",
  "data-name": "Path 512",
  d: "M428.512,281.779,410.95,285.73a3.027,3.027,0,0,0-2.287,3.613l8.262,36.722,33.441-7.523L444.348,291.8A13.267,13.267,0,0,0,428.512,281.779Z",
  transform: "translate(-342.815 -248.851)",
  fill: "#fff"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  id: "Path_513",
  "data-name": "Path 513",
  d: "M477.913,410.266l-22.046,4.96a.736.736,0,1,0,.323,1.437l22.046-4.96a.737.737,0,0,0-.323-1.437Z",
  transform: "translate(-376.794 -342.554)",
  fill: "#e4e4e4"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  id: "Path_514",
  "data-name": "Path 514",
  d: "M475.564,399.834l-22.046,4.96a.737.737,0,0,0,.324,1.439l22.046-4.96a.737.737,0,1,0-.324-1.439Z",
  transform: "translate(-375.084 -334.964)",
  fill: "#e4e4e4"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  id: "Path_515",
  "data-name": "Path 515",
  d: "M460.731,399.722l-9.557,2.15a.737.737,0,1,0,.323,1.437l9.557-2.15a.737.737,0,0,0-.323-1.437Z",
  transform: "translate(-373.38 -334.883)",
  fill: "#e4e4e4"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  id: "Path_516",
  "data-name": "Path 516",
  d: "M468.3,367.566l-22.046,4.96a.737.737,0,1,0,.324,1.439L468.628,369a.737.737,0,0,0-.324-1.439Z",
  transform: "translate(-369.803 -311.487)",
  fill: "#e4e4e4"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  id: "Path_517",
  "data-name": "Path 517",
  d: "M465.96,357.14l-22.046,4.96a.737.737,0,1,0,.323,1.437l22.046-4.96a.737.737,0,1,0-.323-1.437Z",
  transform: "translate(-368.098 -303.902)",
  fill: "#e4e4e4"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  id: "Path_518",
  "data-name": "Path 518",
  d: "M451.122,357.022l-9.557,2.15a.737.737,0,1,0,.324,1.439l9.557-2.15a.737.737,0,0,0-.324-1.439Z",
  transform: "translate(-366.389 -303.816)",
  fill: "#e4e4e4"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  id: "Path_519",
  "data-name": "Path 519",
  d: "M458.7,324.866l-22.046,4.96a.737.737,0,1,0,.324,1.439l22.046-4.96a.737.737,0,1,0-.324-1.439Z",
  transform: "translate(-362.813 -280.42)",
  fill: "#e6e6e6"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  id: "Path_520",
  "data-name": "Path 520",
  d: "M456.352,314.44l-22.046,4.96a.737.737,0,0,0,.324,1.439l22.046-4.96a.737.737,0,0,0-.324-1.439Z",
  transform: "translate(-361.107 -272.835)",
  fill: "#e6e6e6"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  id: "Path_521",
  "data-name": "Path 521",
  d: "M441.516,314.322l-9.557,2.15a.737.737,0,0,0,.324,1.439l9.557-2.15a.737.737,0,1,0-.324-1.439Z",
  transform: "translate(-359.399 -272.75)",
  fill: "#e6e6e6"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  id: "Path_522",
  "data-name": "Path 522",
  d: "M287.675,429.241a.789.789,0,0,0-.788.788V511.5a.789.789,0,0,0,.788.788H389.825a.789.789,0,0,0,.788-.788V443.107a.789.789,0,0,0-.788-.788H331.2a2.388,2.388,0,0,1-1.609-.622l-13.18-11.976a1.844,1.844,0,0,0-1.243-.48Z",
  transform: "translate(-254.269 -356.373)",
  fill: "#3f3d56"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  id: "Path_523",
  "data-name": "Path 523",
  d: "M493.525,286.923l-54.7-23.515a6.025,6.025,0,0,0-7.906,3.152l-28.66,66.665,64.265,27.628a2.991,2.991,0,0,0,1.675.207l28.474-66.232A6.025,6.025,0,0,0,493.525,286.923Z",
  transform: "translate(-338.212 -235.365)",
  fill: "#e6e6e6"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  id: "Path_524",
  "data-name": "Path 524",
  d: "M482.3,298.931,452.33,286.045a5.487,5.487,0,0,0-7.2,2.868l-26.946,62.678,57.077,24.538,19.624-45.646A24.046,24.046,0,0,0,482.3,298.931Z",
  transform: "translate(-349.796 -251.865)",
  fill: "#fff"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  id: "Path_525",
  "data-name": "Path 525",
  d: "M495.314,538.621l-37.629-16.177a1.335,1.335,0,0,0-1.055,2.453l37.629,16.177a1.335,1.335,0,1,0,1.055-2.453Z",
  transform: "translate(-377.18 -424.104)",
  fill: "#e4e4e4"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  id: "Path_526",
  "data-name": "Path 526",
  d: "M502.963,520.817l-37.629-16.177a1.336,1.336,0,1,0-1.056,2.455l37.629,16.177a1.336,1.336,0,0,0,1.056-2.455Z",
  transform: "translate(-382.744 -411.15)",
  fill: "#e4e4e4"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  id: "Path_527",
  "data-name": "Path 527",
  d: "M489.3,493.857l-16.312-7.013a1.335,1.335,0,1,0-1.055,2.453l16.311,7.013a1.335,1.335,0,0,0,1.055-2.453Z",
  transform: "translate(-388.315 -398.204)",
  fill: "#e4e4e4"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  id: "Path_528",
  "data-name": "Path 528",
  d: "M526.641,465.741l-37.629-16.177a1.336,1.336,0,1,0-1.056,2.455L525.585,468.2a1.336,1.336,0,1,0,1.056-2.455Z",
  transform: "translate(-399.971 -371.08)",
  fill: "#e4e4e4"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  id: "Path_529",
  "data-name": "Path 529",
  d: "M534.3,447.946l-37.629-16.177a1.335,1.335,0,1,0-1.055,2.453L533.242,450.4a1.335,1.335,0,0,0,1.055-2.453Z",
  transform: "translate(-405.542 -358.133)",
  fill: "#e4e4e4"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  id: "Path_530",
  "data-name": "Path 530",
  d: "M520.628,420.977l-16.311-7.013a1.336,1.336,0,1,0-1.056,2.455l16.312,7.013a1.336,1.336,0,1,0,1.056-2.455Z",
  transform: "translate(-411.106 -345.179)",
  fill: "#e4e4e4"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  id: "Path_531",
  "data-name": "Path 531",
  d: "M557.973,392.861l-37.629-16.177a1.336,1.336,0,0,0-1.056,2.455l37.629,16.177a1.336,1.336,0,1,0,1.056-2.455Z",
  transform: "translate(-422.767 -318.055)",
  fill: "#f0b543"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  id: "Path_532",
  "data-name": "Path 532",
  d: "M565.624,375.065l-37.629-16.177a1.336,1.336,0,0,0-1.056,2.455l37.629,16.177a1.336,1.336,0,1,0,1.056-2.455Z",
  transform: "translate(-428.333 -305.108)",
  fill: "#f0b543"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  id: "Path_533",
  "data-name": "Path 533",
  d: "M551.961,348.1l-16.311-7.013a1.336,1.336,0,0,0-1.056,2.455l16.312,7.013a1.336,1.336,0,0,0,1.056-2.455Z",
  transform: "translate(-433.902 -292.154)",
  fill: "#f0b543"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  id: "Path_534",
  "data-name": "Path 534",
  d: "M358.942,439.685l-32.046,7.21a3.324,3.324,0,0,0-2.511,3.968l8.787,39.058,37.652-8.471a1.65,1.65,0,0,0,.815-.45l-8.73-38.8a3.324,3.324,0,0,0-3.968-2.511Z",
  transform: "translate(-281.493 -363.913)",
  fill: "#e6e6e6"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  id: "Path_535",
  "data-name": "Path 535",
  d: "M355.512,458.779,337.95,462.73a3.027,3.027,0,0,0-2.287,3.613l8.262,36.722,33.441-7.523L371.348,468.8A13.266,13.266,0,0,0,355.512,458.779Z",
  transform: "translate(-289.703 -377.628)",
  fill: "#fff"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  id: "Path_536",
  "data-name": "Path 536",
  d: "M404.913,587.265l-22.046,4.96a.737.737,0,0,0,.323,1.437l22.046-4.96a.737.737,0,0,0-.323-1.437Z",
  transform: "translate(-323.682 -471.332)",
  fill: "#e4e4e4"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  id: "Path_537",
  "data-name": "Path 537",
  d: "M402.564,576.834l-22.046,4.96a.737.737,0,0,0,.324,1.439l22.046-4.96a.737.737,0,1,0-.324-1.439Z",
  transform: "translate(-321.973 -463.742)",
  fill: "#e4e4e4"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  id: "Path_538",
  "data-name": "Path 538",
  d: "M387.731,576.722l-9.557,2.15a.736.736,0,0,0,.323,1.437l9.557-2.15a.736.736,0,1,0-.323-1.437Z",
  transform: "translate(-320.268 -463.661)",
  fill: "#e4e4e4"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  id: "Path_539",
  "data-name": "Path 539",
  d: "M395.3,544.566l-22.046,4.96a.737.737,0,1,0,.324,1.439L395.628,546a.737.737,0,0,0-.324-1.439Z",
  transform: "translate(-316.691 -440.265)",
  fill: "#e4e4e4"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  id: "Path_540",
  "data-name": "Path 540",
  d: "M392.96,534.14l-22.046,4.96a.737.737,0,0,0,.323,1.437l22.046-4.96a.736.736,0,1,0-.323-1.437Z",
  transform: "translate(-314.986 -432.68)",
  fill: "#e4e4e4"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  id: "Path_541",
  "data-name": "Path 541",
  d: "M378.122,534.022l-9.557,2.15a.737.737,0,1,0,.324,1.439l9.557-2.15a.737.737,0,1,0-.324-1.439Z",
  transform: "translate(-313.277 -432.594)",
  fill: "#e4e4e4"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  id: "Path_542",
  "data-name": "Path 542",
  d: "M385.7,501.866l-22.046,4.96a.737.737,0,1,0,.324,1.439l22.046-4.96a.737.737,0,0,0-.324-1.439Z",
  transform: "translate(-309.702 -409.199)",
  fill: "#e6e6e6"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  id: "Path_543",
  "data-name": "Path 543",
  d: "M383.352,491.44l-22.046,4.96a.737.737,0,1,0,.324,1.439l22.046-4.96a.737.737,0,0,0-.324-1.439Z",
  transform: "translate(-307.995 -401.613)",
  fill: "#e6e6e6"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  id: "Path_544",
  "data-name": "Path 544",
  d: "M368.516,491.322l-9.557,2.15a.737.737,0,1,0,.324,1.439l9.557-2.15a.737.737,0,0,0-.324-1.439Z",
  transform: "translate(-306.287 -401.527)",
  fill: "#e6e6e6"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  id: "Path_545",
  "data-name": "Path 545",
  d: "M285.19,507.787a.788.788,0,0,0-.788.788c0,.029.024,60.707.024,60.707a.787.787,0,0,0,.783.7H394.941a.787.787,0,0,0,.783-.7l6.83-60.619a.788.788,0,0,0-.2-.613.779.779,0,0,0-.587-.263Z",
  transform: "translate(-252.462 -413.52)",
  fill: "#3f3d56"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  id: "Path_546",
  "data-name": "Path 546",
  d: "M304.433,519.39a4.238,4.238,0,0,0-4.225,4.188l.137,47.025a4.225,4.225,0,0,0,4.225,4.262h69.657a32.468,32.468,0,0,0,32.288-28.854l2.47-21.923a4.225,4.225,0,0,0-4.2-4.7Zm106.746,0-.012-.272h.012Z",
  transform: "translate(-263.961 -421.763)",
  fill: "#f0b543"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  id: "Path_547",
  "data-name": "Path 547",
  d: "M352.53,643.819H325.546a1.051,1.051,0,0,1,0-2.1H352.53A1.052,1.052,0,0,1,352.53,643.819Z",
  transform: "translate(-281.631 -510.96)",
  fill: "#e4e4e4"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  id: "Path_548",
  "data-name": "Path 548",
  d: "M388.881,664H325.546a1.051,1.051,0,0,1,0-2.1h63.335A1.052,1.052,0,0,1,388.881,664Z",
  transform: "translate(-281.631 -525.647)",
  fill: "#e4e4e4"
});

function SvgRegisterWebinarsAndDemos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_95_1",
    "data-name": "Component 95 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 235.845,
    height: 157.047,
    viewBox: "0 0 235.845 157.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterWebinarsAndDemos);
export default __webpack_public_path__ + "static/media/register_webinars_and_demos.4cd31629.svg";
export { ForwardRef as ReactComponent };